// extracted by mini-css-extract-plugin
module.exports = {"approvePopup":"styles_approvePopup__1wll0","approveControls":"styles_approveControls__2cnA9"};